/**
 * Set of unique category ids that have a primary color that doesn't look good with their respective logo
 * When this is the case, we default to the accent100 color.
 */
export const SECONDARY_COLOR_CAT_IDS = new Set([
  6350, // Chicago White Sox
  5324, // Philadelphia Phillies
  7562, // San Antonio Spurs
  6564, // Indiana Pacers
  6659, // Washington Capitals
  13_118, // San Jose Sharks
  22_031, // Winnipeg Jets
  287_283, // Colorado Rapids
]);

// Common HTTP methods
export const HTTP_METHODS = {
  DELETE: "delete",
  GET: "get",
  POST: "post",
  PUT: "put",
}; // keyof typeof

// Base header to always apply, can be overriden by headers parameter
export const BASE_HEADERS = {
  headers: { "Content-Type": "application/json" },
};
